import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-pricing',
  templateUrl: './section-pricing.component.html',
  styleUrls: ['./section-pricing.component.scss'],
})
export class SectionPricingComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
